import Image from 'next/image';
import Layout from '../../ui/layout';
import { Wrap, ButtonInverted as Button } from '../../styled';
import { TypeformButtonPartners } from '../../components';
import {
  Intro,
  IntroTextContainer,
  IntroImageContainer,
  IntroHeading,
  IntroSubheading,
  IntroDescription,
  Integration,
  IntegrationGrid,
  IntegrationGridItem,
  IntegrationHeading,
  IntegrationSubheading,
  IntegrationDescription,
  Clients,
  ClientsContainer,
  ClientsCaption,
  ClientsHeading,
  ClientsDescription,
  ClientsBenefits,
  ClientsBenefitsHeading,
  ClientsBenefitsItems,
  ClientsBenefitsItem,
  ClientsBenefitsItemText,
  Growing,
  GrowingContainer,
  GrowingTextContainer,
  GrowingImageContainer,
  GrowingHeading,
  GrowingSubheading,
  GrowingList,
  GrowingListItem,
  Contact,
  ContactHeading,
  ContactDescription,
} from './styled';
import introImage from './images/intro.jpg';
import integrationImage from './images/integration.svg';
import devicesIcon from './images/devices.svg';
import puzzleIcon from './images/puzzle.svg';
import supportIcon from './images/support.svg';
import likeIcon from './images/like.svg';
import laptopImage from './images/laptop.jpg';

const PartnersPage = () => (
  <Layout>
    <Intro>
      <Wrap>
        <IntroTextContainer>
          <IntroHeading>EyeFitU – Partners</IntroHeading>
          <IntroSubheading>
            Your partner in technology, innovation, and growth.
          </IntroSubheading>
          <IntroDescription>
            Leverage the power of EyeFitU’s SizeEngine™ with your CX-focused
            solutions and connect leading brands with consumers.
          </IntroDescription>
          <Button as={TypeformButtonPartners}>Become a Partner</Button>
        </IntroTextContainer>
      </Wrap>
      <IntroImageContainer>
        <Image
          src={introImage}
          alt=""
          style={{ objectFit: 'cover', height: '100%' }}
          priority
        />
      </IntroImageContainer>
    </Intro>
    <Integration>
      <Wrap>
        <IntegrationGrid>
          <IntegrationGridItem>
            <IntegrationHeading>
              Integration – Partner Program
            </IntegrationHeading>
            <IntegrationSubheading>
              We share the same customers. Your success is our success.
            </IntegrationSubheading>
            <IntegrationDescription>
              Are you a designer / developer / systems integrator in the
              ecommerce space intent upon growing your business?
            </IntegrationDescription>
            <IntegrationDescription>
              EyeFitU’s Integration ‒ Partner Program is the growth opportunity
              you’ve been searching for.
            </IntegrationDescription>
          </IntegrationGridItem>
          <IntegrationGridItem>
            <Image src={integrationImage} alt="" />
          </IntegrationGridItem>
        </IntegrationGrid>
      </Wrap>
    </Integration>
    <Clients>
      <Wrap>
        <ClientsHeading>Your clients. Our clients. First.</ClientsHeading>
        <ClientsContainer>
          <ClientsCaption>
            <ClientsDescription>
              EyeFitU’s Integration - Partner Program supports your delivery of
              a world class ecommerce experience to your clients and their
              customers in the fashion industry.
            </ClientsDescription>
          </ClientsCaption>
          <ClientsBenefits>
            <ClientsBenefitsHeading>
              Your clients will benefit from:
            </ClientsBenefitsHeading>
            <ClientsBenefitsItems>
              {[
                {
                  icon: devicesIcon,
                  text: 'The EyeFitU SizeEngine™ and its patented multi-parameter algorithm',
                },
                {
                  icon: puzzleIcon,
                  text: 'Easy and seamless integration across all ecommerce platforms',
                },
                {
                  icon: supportIcon,
                  text: 'Comprehensive support from the EyeFitU sales and technical teams',
                },
                {
                  icon: likeIcon,
                  text: 'Preferential pricing structure for all clients introduced through the Integration ‒ Partner Program',
                },
              ].map(({ text, icon }) => (
                <ClientsBenefitsItem key={text}>
                  <Image src={icon} alt="" width={80} height={80} />
                  <ClientsBenefitsItemText>{text}</ClientsBenefitsItemText>
                </ClientsBenefitsItem>
              ))}
            </ClientsBenefitsItems>
          </ClientsBenefits>
        </ClientsContainer>
      </Wrap>
    </Clients>
    <Growing>
      <Wrap>
        <GrowingContainer>
          <GrowingTextContainer>
            <GrowingHeading>Growing. Together.</GrowingHeading>
            <GrowingSubheading>
              Grow your business by partnering with EyeFitU
            </GrowingSubheading>
            <GrowingList>
              {[
                'Earn additional revenue with recurring commissions.',
                'Raise brand awareness and participate in joint marketing opportunities in the fashion industry with EyeFitU.',
                'Empower your sales and technical teams with technical, training, marketing, and sales materials.',
                'Need assistance, quickly? Your dedicated EyeFitU Partner Manager is your go-to resource.',
              ].map((i) => (
                <GrowingListItem key={i}>{i}</GrowingListItem>
              ))}
            </GrowingList>
          </GrowingTextContainer>
          <GrowingImageContainer>
            <Image src={laptopImage} alt="" />
          </GrowingImageContainer>
        </GrowingContainer>
      </Wrap>
    </Growing>
    <Contact>
      <Wrap>
        <ContactHeading>
          Are you interested in becoming a partner?
        </ContactHeading>
        <ContactDescription>
          Fill in the form and we’ll contact you shortly.
        </ContactDescription>
        <Button as={TypeformButtonPartners}>Become a Partner</Button>
      </Wrap>
    </Contact>
  </Layout>
);

export default PartnersPage;
